import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core';
import { withRouter } from "react-router-dom";
// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';
import { Link, NavLink } from 'react-router-dom';
// Material table
import MaterialTable from 'material-table'
import ContactTable from "./components/ContactTable.jsx"
// Material Kit
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
// import Button from "components/CustomButtons/Button.jsx";

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// import { cardTitleWhite, cardCategoryWhite } from "assets/jss/material-kit-pro-react.jsx";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class Dashboard extends Component {
  render() {
    const { classes } = this.props;
    const { confirm } = this.props;

    return (
      <ApplicationLayout title="Dashboard">
        <div className={classes.root}>
          <Grid
            container
            spacing={8}
          >
            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  2.000 LEADS
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
                <Link to="/leads">
                  <Button size="small">List</Button>
                </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  4.001 CONTACTS
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
                <Link to="/contacts">
                  <Button size="small">List</Button>
                </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  5 MP PUBLISED
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
                <Link to="/deals">
                  <Button size="small">List</Button>
                </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  2.000 MP OPERATIONS
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
              <Link to="/deals">
                <Button size="small">List</Button>
              </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  2.000 MP OPERATIONS
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
              <Link to="/deals">
                <Button size="small">List</Button>
              </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={4}
              sm={4}
              xl={4}
              xs={4}
            >
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  User: admin, tenant: demo
                </Typography>
                <Typography variant="h5" component="h2">
                  2.000 MP OPERATIONS
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  adjective
                </Typography>
                <Typography component="p">
                  well meaning and kindly.
                  <br />
                  {'"a benevolent smile"'}
                </Typography>
              </CardContent>
              <CardActions>
              <Link to="/deals">
                <Button size="small">List</Button>
              </Link>
              </CardActions>
              </Card>
            </Grid>

            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
            <Card className={classes.card}>
              <CardContent>
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                User: admin, tenant: demo
              </Typography>
              <Typography variant="h5" component="h2">
                Recent clients
              </Typography>
                <ContactTable/>
              </CardContent>
              <CardActions>
              <Link to="/deals">
                <Button size="small">List</Button>
              </Link>
              </CardActions>
              </Card>
            </Grid>

          </Grid>
        </div>
      </ApplicationLayout>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withAuth,
  withStyles(styles),
  withRouter
)(Dashboard);
